<template>
  <div class="employeeslist">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Transfered Employees</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">
                    Transfered Employees
                  </li>
                </ul>
              </div>
              <!-- <div class="col-auto float-right ml-auto">
                <a class="btn add-btn" @click="openDialog"
                  ><i class="fa fa-plus"></i> Transfer Employee</a
                >
              </div> -->
            </div>
          </div>

          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <v-data-table
                :headers="headers"
                :items="transferedEmployees"
                sort-by=""
                class="elevation-1"
              >
                <template v-slot:[`item.dateJoined`]="{ item }">
                  {{
                    item.dateJoined
                      ? new Date(item.dateJoined).toLocaleDateString()
                      : item.dateJoined
                  }}
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <div class="dropdown dropdown-action">
                    <a
                      href="#"
                      class="action-icon dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                      ><i class="material-icons">more_vert</i></a
                    >
                    <div class="dropdown-menu dropdown-menu-right">
                      <a
                        class="dropdown-item"
                        @click="setTransferStatus(item)"
                        v-if="item.status == 0 && item.approvedBy == null"
                        ><i class="fa fa-trash-o m-r-5"></i> Approve / Reject</a
                      >
                      <a class="dropdown-item" @click="setDeleteTransfer(item)"
                        ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                      >
                    </div>
                  </div>
                </template>
                <template v-slot:[`item.profile`]="{ item }">
                  <h2 class="table-avatar blue-link">
                    <div class="avatar">
                      <img
                        alt=""
                        src="~@/assets/profiles/avatar-02.jpg"
                        v-if="!item.employee.passportPhoto"
                      />
                      <img
                        alt=""
                        :src="media + item.employee.passportPhoto"
                        width="38"
                        v-if="item.employee.passportPhoto"
                      />
                    </div>
                    <div>
                      {{
                        `${item.employee.firstName} ${item.employee.lastName}`
                      }}
                    </div>
                  </h2>
                </template>
                <template v-slot:[`item.stat`]="{ item }">
                  <a
                    class="btn btn-white btn-sm btn-rounded"
                    v-if="item.status == 0"
                    aria-expanded="false"
                  >
                    <i class="fa fa-dot-circle-o text-purple"></i> New
                  </a>
                  <a
                    class="btn btn-white btn-sm btn-rounded"
                    v-if="item.status == 1"
                    aria-expanded="false"
                  >
                    <i class="fa fa-dot-circle-o text-success"></i> Approved
                  </a>
                  <a
                    class="btn btn-white btn-sm btn-rounded"
                    v-if="item.status == 2"
                    aria-expanded="false"
                  >
                    <i class="fa fa-dot-circle-o text-danger"></i> Declined
                  </a>
                </template>
              </v-data-table>
            </div>
          </div>
          <!---/Datatable-->
        </div>

        <!-- HR approve dialog -->

        <v-dialog v-model="dialogStatus" max-width="500px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button type="button" class="close" @click="closeStatus">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Employee Transfer</h3>
                <p>Are you sure want to approve for this employee?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click="changeTransferStatus(1)"
                      class="btn btn-primary continue-btn"
                      >Approve</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      @click="changeTransferStatus(2)"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      >Decline</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- HR approve dialog ends -->
        <!-- Delete Promotion Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <!-- <div
          class="modal custom-modal fade"
          id="delete_promotion"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered"> -->
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Delete Transfer</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click.prevent="deleteTransfer"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- </div>
        </div> -->
        </v-dialog>
        <!-- /Delete Promotion Modal -->
        <!-- /Page Content -->

        <!-- Add Employee Modal -->
        <v-dialog v-model="dialogAdd" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Transfer Employee</h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="addTransferedEmployee">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label>Select Employee:</label>
                      <select class="form-control" v-model="employeeName">
                        <option disabled>Select Employee</option>
                        <option
                          v-for="item in employees"
                          :key="item.id"
                          :value="parseInt(item.id)"
                        >
                          {{ item.firstName }} {{ item.lastName }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row col-12">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Business Unit From:</label>
                        <select
                          class="form-control"
                          v-model="companyunitIdFrom"
                        >
                          <option disabled>Select Business Unit</option>
                          <option
                            v-for="item in units"
                            :key="item.id"
                            :value="parseInt(item.id)"
                          >
                            {{ item.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Business Unit To: </label>
                        <select class="form-control" v-model="companyunitIdTo">
                          <option disabled>Select Business Unit</option>
                          <option
                            v-for="item in units"
                            :key="item.id"
                            :value="parseInt(item.id)"
                          >
                            {{ item.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>
                          To Department
                          <span class="text-danger">*</span></label
                        >
                        <select
                          id="department"
                          name="department"
                          class="form-control"
                          v-model="toDepartmentId"
                        >
                          <option disabled>Select Department</option>
                          <option
                            v-for="item in departments"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>
                          To Designation
                          <span class="text-danger">*</span></label
                        >
                        <input
                          type="text"
                          v-model="toDesignationId"
                          id="name"
                          name="name"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="form-group wrapper-class">
                      <label
                        >Effective Date
                        <span class="text-danger">*</span></label
                      >
                      <div class="cal-icon">
                        <datepicker
                          v-model="dateJoined"
                          calendar-class
                          input-class
                          bootstrap-styling
                          class="form-control datetimepicker"
                          type="text"
                        />
                        <!-- <input class="form-control datetimepicker" type="text"> -->
                      </div>
                    </div>
                  </div>
                </div>

                <div class="submit-section">
                  <button class="btn btn-primary submit-btn" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>

        <!-- /Add Employee Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { required, numeric, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService.js";
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from "@/services/organizationService";
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  data() {
    return {
      company: authenticationService.currentOfficeValue,
      requestDate: new Date(),
      media: "data:image/jpeg;base64,",
      headers: [
        {
          text: "Employee",
          align: "start",
          value: "profile"
        },
        { text: "From Bus. Unit", value: "fromUnit.name" },
        { text: "From Position", value: "fromDesignation.name" },
        { text: "From Level", value: "fromRank.rankName" },
        { text: "To Bus.Unit", value: "toUnit.name" },
        { text: "To Position", value: "toDesignation.name" },
        { text: "To Level", value: "toRank.rankName" },
        { text: "Effective Date", value: "dateJoined" },
        { text: "Status", value: "stat" },
        { text: "Action", value: "actions", sortable: false }
      ],
      transferedEmployees: [],
      employees: [],
      employee: {},
      transfer: {},
      message: "",
      units: [],
      dialogStatus: false,
      dialogDelete: false,
      submitted: false,
      departments: [],
      designations: [],
      loading: false,
      companyunitIdTo: "",
      companyunitIdFrom: "",
      toDepartmentId: null,
      toDesignationId: null,
      dateJoined: "",
      employeeName: "",
      currentUserFullName: "",
      error: "",
      dialogAdd: false
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogStatus(val) {
      val || this.closeStatus();
    },
    getDesignations() {
      organizationService.getDesignations().then(
        model => {
          this.designations = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getDepartments() {
      organizationService.getDepartments().then(
        model => {
          this.departments = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    }
    // dialogEdit(val) {
    //   val || this.closeEdit();
    // },
  },
  created() {
    this.getCurrentUser();
    this.GetUnits();
    this.GetEmployees();
    this.getDesignations();
    this.getDepartments();
    this.GetTransferedEmployees();
  },

  methods: {
    GetEmployees() {
      this.loading = true;
      let currentUserDepart = JSON.parse(localStorage.getItem("currentUser"));
      employeeService
        .getEmployeesByDepart(
          currentUserDepart.employee.designation.departmentId
        )
        .then(
          model => {
            this.employees = model;
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    },

    GetTransferedEmployees() {
      this.loading = true;
      let currentUserDepart = JSON.parse(localStorage.getItem("currentUser"));
      employeeService
        .GetTransferedEmployeesByDepart(
          currentUserDepart.employee.designation.departmentId,
          currentUserDepart.employee.companyUnitId
        )
        .then(
          model => {
            this.transferedEmployees = model;
            console.log(this.transferedEmployees);
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    },

    GetUnits() {
      organizationService.getCompanyUnits(this.company.id).then(
        model => {
          this.units = model;

          var unitStrings = "";
          model.forEach(t => {
            unitStrings += t.id + " - " + t.name + ", ";
          });
          this.unitStrings = unitStrings;
        },
        error => {
          this.error = error;
        }
      );
    },

    getCurrentUser() {
      let currentUser = JSON.parse(localStorage.getItem("currentUser"));
      this.currentUserId = currentUser.employee;
      this.currentUserFullName =
        currentUser.employee.firstName + " " + currentUser.employee.lastName;
    },

    addTransferedEmployee() {
      this.submitted = true;
      employeeService
        .addTransferedEmployee(
          this.employeeName,
          this.companyunitIdFrom,
          this.companyunitIdTo,
          this.toDesignationId,
          this.dateJoined,
          this.currentUserFullName,
          this.requestDate
        )
        .then(() => {
          this.GetTransferedEmployees();
          this.dialogAdd = false;
        });
    },
    deleteTransfer() {
      const id = this.transfer.id;
      employeeService.removeEmployeeTransfer(id).then(
        id => {
          let currentUserDepart = JSON.parse(
            localStorage.getItem("currentUser")
          );
          employeeService
            .GetTransferedEmployeesByDepart(
              currentUserDepart.employee.designation.departmentId,
          currentUserDepart.employee.companyUnitId
            )
            .then(model => {
              this.transferedEmployees = model;
            });
        },
        error => {
          this.error = error;
        }
      );
    },

    close() {
      this.dialogAdd = false;
      // this.clearModel();
    },
    closeStatus() {
      this.dialogStatus = false;
      // this.clearModel();
    },

    changeTransferStatus(status) {
      this.submitted = true;
      const id = this.transfer.id;
      this.transfer.status = status == 1 ? 0 : 2;
      this.transfer.approvedByHOD = this.currentUserFullName;
      this.transfer.approvedDateByHOD = new Date();
      this.loading = true;
      employeeService.updateTransferedEmployee(id, this.transfer).then(
        id => {
          let currentUserDepart = JSON.parse(
            localStorage.getItem("currentUser")
          );
          employeeService
            .GetTransferedEmployeesByDepart(
              currentUserDepart.employee.designation.departmentId,
          currentUserDepart.employee.companyUnitId
            )
            .then(model => {
              this.transferedEmployees = model;
              this.closeStatus();
            });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );

      console.log("jjsh");
    },

    openDialog() {
      this.dialogAdd = true;
    },
    setTransferStatus(item) {
      this.dialogStatus = true;
      this.transfer = item;
    }
  },

  mounted() {
    this.GetTransferedEmployees();
  },

  name: "employeeslist"
};
</script>



// WEBPACK FOOTER //
// src/components/employees/employeeTransfer.vue